import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';

import { isIE } from '@common';

import { viguideVersion } from '../../package-version';
import { environment } from '../environments/environment';

if (environment.sentry) {
  Sentry.init({
    dsn: 'https://ad0d92ebe566439bb00107aec5586fae@sentry.dev.viessmann-climatesolutions.com/2',
    environment: environment.env,
    release: viguideVersion,
  });
}

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  isModernBrowser: boolean;

  constructor() {
    this.isModernBrowser = !isIE();
  }

  handleError(error: any): void {
    // throw error to console when query param is in url ?showErrors=true
    const urlParams = new URLSearchParams(window.location.search);
    const showErrors = urlParams.get('showErrors');

    if (!(error instanceof Error)) {
      error = new Error(error);
    }

    if (environment.sentry && error && this.isModernBrowser) {
      Sentry.captureException(error.originalError || error);
    }

    if (environment.env !== 'production' || showErrors) {
      throw error;
    }
  }
}
